import { login } from "../../features/authSlice";
import { IAuthState } from "../../features/authSlice/authSlice.types";
import { apiSlice } from "../apiSlice";
import { ILoginProps } from "./authApi.types";

const authApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        loginApi: builder.mutation({
            query: (body: ILoginProps) => {
                return {
                    url: "/api/auth/merchant/signin",
                    method: "POST",
                    body: body,
                    // responseHandler: async (response: { text: () => any }) => {
                    //     const responseText = await response.text();
                    //     try {
                    //         return {
                    //             accessToken: responseText
                    //         };
                    //     } catch (error) {
                    //         throw new Error('Failed to parse response as JSON');
                    //     }
                    // }
                };
            },
            async onQueryStarted(arg: any, { queryFulfilled, dispatch }: any) {
                try {
                    const result: any = await queryFulfilled;
                    const { data } = result;
                    dispatch(login(data as IAuthState));
                } catch (error) {}
            },
        }),

        createMerchant: builder.mutation({
            query: (body) => {
                return {
                    url: `/api/auth/merchant/signup`,
                    method: 'POST',
                    body
                }
            }
        }),
    }),
    overrideExisting: true,
});

export const { useLoginApiMutation, useCreateMerchantMutation } = authApiSlice;
